import { LITE_SEARCH_POP_SHOW_STATUS } from "./../constants/types";
import { GetterTree } from "vuex";
import * as types from "@/store/constants/types";
const Getters: GetterTree<any, any> = {
  [types.LITE_SEARCH_POP_SHOW_STATUS](state, getters, rootState) {
    return state.liteSearchShow;
  },
  [types.VIP_RETAIN_DIALOG_SHOW](state, getters, rootState) {
    return state.retainDialogShow;
  }
};

export default Getters;
